


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import WarehouseResortForm from '../WarehouseResortForm/WarehouseResortForm.vue'

import TitleBar from '@/components/Elements/TitleBar.vue'
import moment from 'moment'

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta', 'days',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WarehouseResortList extends Vue {
  public warehouse_id: any = null;
  public targetDates: any[] = [];
  public actor!: any;

  get titleStack () {
    return [
      'Расхождения остатков'
    ]
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'quantity', this.$route.query.sortDirection || 'asc']
  }

  unselectableDates(day: any) {
    return moment().date() > moment(day).date()
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  onWarehouseChange(warehouse_id: string) {
    console.log('onWarehouseChange', warehouse_id)
    this.$router.replace({
      query: { ...this.$route.query, warehouse_id }
    })
  }


  openWarehousesResortForm(warehouse_id: any) {
    const manager_id = this.actor.document.id
    this.$buefy.modal.open({
      component: WarehouseResortForm,
      props: {
        isNew: true,
        initParams: {
          warehouse_id,
          manager_id
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query.since) {
      this.targetDates = [
        // @ts-ignore
        moment(this.$route.query.since).toDate(),
        // @ts-ignore
        moment(this.$route.query.until).toDate(),
      ]
    }else {
      this.targetDates = [moment().toDate(), moment().add(1, 'day').toDate()]
    }
    if (this.$route.query.warehouse_id) {
      this.warehouse_id = this.$route.query.warehouse_id
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
    }
  }

}
